<template>
  <v-container fluid>
    <page-header />

    <datatable
      :isLoading="tableLoading"
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :itemTotal="tableTotal"
      :page.sync="tableFilter.page"
      :pageLimit.sync="tableFilter.limit"
      disableToolbar
      @options-update="getList()"
    >
      <template v-slot:[`item.type`]="{ item }">
        <span v-if="item.type">{{ $t(`planTypeOption.${item.type}`) }}</span>
      </template>
    </datatable>
  </v-container>
</template>

<script>
import Datatable from '@/components/Datatable.vue'
export default {
  name: 'EnquiryList',
  components: {
    Datatable,
  },
  data: vm => ({
    tableLoading: false,
    tableData: [],
    tableTotal: 0,
    tableFilter: {
      page: 1,
      limit: 10,
    },
    tableHeaders: [
      { value: 'create_date', text: vm.$t('submitDate'), width: 130 },
      { value: 'name', text: vm.$t('title'), width: 150 },
      { value: 'phone', text: vm.$t('contactMobile') },
      { value: 'email', text: vm.$t('contactEmail') },
      { value: 'type', text: vm.$t('enquiryType') },
      { value: 'content', text: vm.$t('content'), width: 450 },
    ],
  }),
  methods: {
    async getList(regenUrl = true) {
      if (regenUrl) {
        this.regenerateURL()
      }

      this.tableLoading = true
      try {
        const payload = {
          filter_page: this.tableFilter.page - 1,
          filter_limit: this.tableFilter.limit,
        }
        const { total, data } = await this.$Fetcher.GetEnquiries(payload)
        this.tableTotal = total
        this.tableData = data;
      } catch (err) {
        this.$common.error(err)
        this.tableData = []
      } finally {
        this.tableLoading = false
      }
    },

    getQuery() {
      const query = this.$route.query
      if (Object.keys(query).length > 0) {
        if (this.$validate.DataValid(query.p) && this.$validate.regexNumber(query.p)) {
          this.tableFilter.page = parseInt(query.p)
        }

        if (this.$validate.DataValid(query.l) && this.$validate.regexNumber(query.l)) {
          this.tableFilter.limit = parseInt(query.l)
        }
      }
    },
    regenerateURL() {
      const query = this.$route.query
      let q = {
        p: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.page : null,
        l: this.tableFilter.limit !== 10 || this.tableFilter.page !== 1 ? this.tableFilter.limit : null,
      }
      const newQuery = this.$common.diffQuery(q, query)
      if (newQuery) {
        this.$router.replace({ query: newQuery })
      }
    },
  },

  async mounted() {
    this.getQuery()
    this.getList(false)
  },
}
</script>
